import Line from './Line';
import Typography from './Typography';
import Media from './Media';
import Paragraph from './Paragraph';

export { default as withPlaceholder } from './withPlaceholder';

export {
  Line,
  Typography,
  Media,
  Paragraph,
};

export default {
  Line,
  Typography,
  Media,
  Paragraph,
};



// WEBPACK FOOTER //
// ./src/@ui/Placeholder/index.js